<template>
    <div class="base-form-div">
        <el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="现象名称" prop="fsname">
                <el-input placeholder="请输入现象名称" v-model="ruleForm.fsname"></el-input>
            </el-form-item>
            <div class="form-bottom">
                <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">修改</el-button>
                <el-button class="base-button" size="mini" @click="resetForm('ruleForm')">重置</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import { updateGzxx } from "@/api/equipmentDic/index.js"
export default {
    props: ["subData"],
    data() {
        return {
            typeOptions: [{
                key: '1412261015343639',
                label: '052C'
            }, {
                key: '504012158172549',
                label: '054A'
            }],
            pidname:"",
            ruleForm: {
                fsid:"",
                fsname: ""
            },
            rules: {
                fsname: [
                    { required: true, message: "请输入现象名称", trigger: "blur" },
                    {
                        min: 2,
                        max: 50,
                        message: "长度在 2 到 50 个字符",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    methods: {
        submitForm(formName) {
            console.log(this.ruleForm);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    updateGzxx(this.ruleForm).then(() => {
                        this.$message({
                            message: "修改成功",
                            type: "success",
                        });
                        this.$bus.$emit("faultPheon-list");
                        this.$parent.close();
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    },
    created() {
        this.ruleForm.fsid = this.subData.obj.fsid;
        this.ruleForm.fsname = this.subData.obj.fsname;
        this.ruleForm.type = this.subData.obj.type;
    },
    mounted() { },
};
</script>
<style>
.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}
</style>